import * as styles from "./StatusIcon.styles.ts";
import SuccessIcon from "./assets/success.svg?react";
import ErrorIcon from "./assets/error.svg?react";
import WarningIcon from "./assets/warning.svg?react";
import WarningAnimatedIcon from "./assets/warning-animated.svg?react";
import InfoIcon from "./assets/info.svg?react";

type StatusIconProps = {
  severity: "info" | "success" | "error" | "warning";
  pulsate?: boolean;
};

export const StatusIcon = ({ severity, pulsate = false }: StatusIconProps) => {
  if (pulsate && severity !== "warning") {
    throw new Error(`pulsate is not supported for ${severity} severity`);
  }
  return (
    <div css={styles.icon({ severity })}>
      {
        {
          error: <ErrorIcon />,
          info: <InfoIcon />,
          success: <SuccessIcon />,
          warning: pulsate ? <WarningAnimatedIcon /> : <WarningIcon />,
        }[severity]
      }
    </div>
  );
};
